





































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import RootCauseCategoryModel from '@/models/investigation/rootCauseCategoryModel'
import RootCauseModel from '@/models/investigation/rootCauseModel'
import RootCauseAnswerModel from '@/models/investigation/rootCauseAnswerModel'
import apiService from '../../services/apiService'
import { UrlType } from '@/constants/urlType'

@Component
export default class RootCauseList extends Vue {
  @Prop(String) readonly investigationId!: string
  @Prop(Array) readonly categories!: Array<RootCauseCategoryModel>
  @Prop(Boolean) readonly disabled!: boolean

  private selected: Array<RootCauseModel> = []

  @Emit()
  private async answerToggled(question: RootCauseModel): Promise<void> {
    if (!question.isChecked) {
      this.createAnswer(question)
    } else {
      this.deleteAnswer(question)
    }
  }

  private async createAnswer(question: RootCauseModel): Promise<void> {
    await apiService.post<RootCauseAnswerModel>(
      UrlType.ExtensionRootCauseAnswer,
      new RootCauseAnswerModel({
        rootMapId: question.rootMapId,
        extensionInvestigationId: this.investigationId
      })
    )
  }

  private async deleteAnswer(question: RootCauseModel): Promise<void> {
    await apiService.delete(UrlType.ExtensionRootCauseAnswer, question.answerId)
  }

  @Watch('categories', { immediate: true })
  private onCategoriesChanged() {
    for (const category of this.categories) {
      const checked = category.value.filter(x => x.isChecked)
      this.selected.push(...checked)
    }
  }
}
